import request from '../utils/http'
// 学生激活码列表
export function index (query) {
  return request({
    url: '/studentActiveCode/list',
    method: 'GET',
    params: query
  })
}
// 新增学生激活码
export function save (query) {
  return request({
    url: '/studentActiveCode/save',
    method: 'POST',
    data: query
  })
}
// 编辑学生激活码
export function edit (query) {
  return request({
    url: '/studentActiveCode/edit',
    method: 'GET',
    params: query
  })
}
// 更新学生激活码
export function update (query) {
  return request({
    url: '/studentActiveCode/update',
    method: 'POST',
    data: query
  })
}
// 删除学生激活码
export function del (query) {
  return request({
    url: '/studentActiveCode/delete',
    method: 'DELETE',
    data: query
  })
}
// 学生激活码开关
export function show (query) {
  return request({
    url: '/studentActiveCode/show',
    method: 'POST',
    data: query
  })
}
// 学生激活码批量新增
export function batch (query) {
  return request({
    url: '/studentActiveCode/batch',
    method: 'POST',
    data: query
  })
}
// 导出激活码
export function studentCodeExport (query) {
  return request({
    url: '/studentActiveCode/export',
    method: 'POST',
    responseType: 'blob',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/studentCode.js